import * as React from 'react';

import UserApi from '../modules/users/api/UserApi';
import {Form, Header, Button, Input, Breadcrumb} from 'semantic-ui-react';
import Page from './Page';
import {RouteComponentProps} from 'react-router';
import Registry from '../global/Registry';
import {Link} from 'react-router-dom';

interface State {
	businessName: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	password: string;
}

export default class BusinessSignUpPage extends Page<RouteComponentProps<void>, State> {

	public constructor (props: RouteComponentProps<void>) {
		super(props);

		this.state = {
			businessName: '',
			firstName: '',
			lastName: '',
			emailAddress: '',
			password: ''
		};
	}

	protected isLoading (): any {
		return false;
	}

	protected renderTitle (): string {
		return 'Business Sign up - Brain Brooder';
	}

	protected renderDescription (): string {
		return 'Sign up for Brain Brooder and upgrade your employees.';
	}

	protected getPageName () {
		return 'SignUpBusiness';
	}

	protected renderContent () {
		const me = Registry.getInstance().me;

		const sections = [{ key: 'Home', content: <Link to={'/businesses'}>Home</Link> }, { key: 'Course', content: 'Business sign up', active: true }];

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Business sign up</Header>

				<Form inverted onSubmit={this.signUp} style={{textAlign: 'center'}}>
					<div>
						<Header color={'orange'} as='h3'>Your business</Header>

						<Form.Field>
							<label>Business name</label>
							<Input autoFocus transparent maxLength={32} type='text' placeholder='Business name' value={this.state.businessName} onChange={(event: any) => this.setState({businessName: event.target.value})}/>
						</Form.Field>
					</div>

					{me.isSignedUp() ? null : (
						<div style={{marginTop: '32px'}}>
							<Header color={'orange'} as='h3'>You</Header>

							<Form.Group widths={'equal'}>
								<Form.Field>
									<label>First name</label>
									<Input transparent maxLength={32} type='text' placeholder='First name' value={this.state.firstName} onChange={(event: any) => this.setState({firstName: event.target.value})}/>
								</Form.Field>

								<Form.Field>
									<label>Last name</label>
									<Input transparent maxLength={32} type='text' placeholder='Last name' value={this.state.lastName} onChange={(event: any) => this.setState({lastName: event.target.value})}/>
								</Form.Field>
							</Form.Group>

							<Form.Field>
								<label>Email address</label>
								<Input transparent type='text' placeholder='Email address' value={this.state.emailAddress} onChange={(event: any) => this.setState({emailAddress: event.target.value})}/>
							</Form.Field>

							<Form.Field>
								<label>Password</label>
								<Input transparent type='password' placeholder='Password' value={this.state.password} onChange={(event: any) => this.setState({password: event.target.value})}/>
							</Form.Field>
						</div>
					)}

					<Button color={'blue'} size={'big'} inverted type='submit' style={{marginTop: '36px'}}>Sign up my business</Button>
				</Form>
			</div>
		);
	}

	private signUp = async (event: Event) => {
		event.preventDefault();

		await UserApi.getInstance().signUpOrganization('BUSINESS', this.state.businessName, this.state.firstName, this.state.lastName, this.state.emailAddress, this.state.password);

		Page.navigate('/');
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/BusinessSignUpPage.tsx